/**
 * 金额文本组件：复用 utils/format 的 formatMoney 格式化展示。
 *
 * @module components/common/MoneyText
 */
import Typography, { type TypographyProps } from '@mui/material/Typography';
import { formatMoney } from '@/utils/format';

/** MoneyText 属性。 */
export interface MoneyTextProps extends Omit<TypographyProps, 'children'> {
  /** 金额（字符串或数字）。 */
  value: string | number;
  /** 小数位数。 */
  fractionDigits?: number;
  /** 货币前缀，默认 ¥。 */
  prefix?: string;
}

/**
 * 金额展示组件。
 *
 * @param props 组件属性。
 * @returns JSX 元素。
 */
export default function MoneyText({
  value,
  fractionDigits = 2,
  prefix = '¥',
  ...rest
}: MoneyTextProps): JSX.Element {
  return (
    <Typography component="span" {...rest}>
      {prefix}
      {formatMoney(value, fractionDigits)}
    </Typography>
  );
}
